module.exports = __webpack_public_path__ + "static/media/S2N7-5.c8164471.svg";